import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Instagram, MapPin, Phone } from 'lucide-react';

export const Footer = () => {
  const { t, language, isRTL } = useLanguage();
  const logoIcon = "https://customer-assets.emergentagent.com/job_nina-beauty-academy/artifacts/79ucravx_WhatsApp_Image_2026-03-09_at_11.56.55_PM__1_-removebg-preview.png";

  const quickLinks = [
    { path: '/', label: t.nav.home },
    { path: '/courses', label: t.nav.courses },
    { path: '/schedule', label: t.nav.schedule },
    { path: '/services', label: t.nav.services },
    { path: '/gallery', label: t.nav.gallery },
    { path: '/contact', label: t.nav.contact },
  ];

  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-white">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <img 
                src={logoIcon} 
                alt="NC" 
                className="h-9 w-auto object-contain brightness-0 invert"
              />
              <span className="font-playfair text-3xl font-medium text-white">
                Nina Beauty
              </span>
            </Link>
            <p className="font-manrope text-gray-400 leading-relaxed mb-4 max-w-md">
              {language === 'en'
                ? 'International Beauty Educator & Top Master. Professional nail and lash training academy in Riyadh.'
                : 'مدربة تجميل دولية وخبيرة معتمدة. أكاديمية تدريب احترافية للأظافر والرموش في الرياض.'}
            </p>
            <p className="font-manrope text-gray-500 text-sm leading-relaxed mb-6 max-w-md">
              {language === 'en'
                ? 'Empowering women to build successful careers in the beauty industry through professional education and modern techniques.'
                : 'نمكّن النساء من بناء مسيرات مهنية ناجحة في صناعة التجميل من خلال التعليم الاحترافي والتقنيات الحديثة.'}
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://instagram.com/ninaceban_riyadh"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-12 h-12 rounded-full bg-[#C5A059]/10 flex items-center justify-center hover:bg-[#C5A059] transition-all duration-300 group"
              >
                <Instagram className="w-5 h-5 text-[#C5A059] group-hover:text-white transition-colors duration-300" />
              </a>
              <a
                href="https://wa.me/966599385282"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="w-12 h-12 rounded-full bg-[#C5A059]/10 flex items-center justify-center hover:bg-[#C5A059] transition-all duration-300 group"
              >
                <Phone className="w-5 h-5 text-[#C5A059] group-hover:text-white transition-colors duration-300" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-playfair text-lg font-medium mb-6 text-[#C5A059]">
              {language === 'en' ? 'Quick Links' : 'روابط سريعة'}
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-manrope text-gray-400 hover:text-[#C5A059] transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-playfair text-lg font-medium mb-6 text-[#C5A059]">
              {t.contact.subtitle}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C5A059] flex-shrink-0 mt-0.5" />
                <span className="font-manrope text-gray-400">
                  {t.contact.riyadh}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#C5A059] flex-shrink-0 mt-0.5" />
                <a
                  href="tel:+966599385282"
                  className="font-manrope text-gray-400 hover:text-[#C5A059] transition-colors duration-300"
                >
                  +966 599 385 282
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-manrope text-gray-500 text-sm">
            © 2026 Nina Beauty Academy. {t.footer.rights}.
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-manrope text-gray-500 text-sm hover:text-[#C5A059] transition-colors duration-300"
          >
            {t.nav.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
};
